export const tabActiveKey = (prefix: string) => `${prefix}ActiveTab`;

export const tabPageKey = (prefix: string, tabKey: string) =>
  `${prefix}Page-${tabKey}`;

export const getStoredActiveTab = (prefix: string, fallback = "1") =>
  sessionStorage.getItem(tabActiveKey(prefix)) || fallback;

export const getStoredTabPage = (prefix: string, tabKey: string) =>
  Number(sessionStorage.getItem(tabPageKey(prefix, tabKey))) || 1;

export const setStoredTabPage = (
  prefix: string,
  tabKey: string,
  page: number
) => sessionStorage.setItem(tabPageKey(prefix, tabKey), String(page));

export const setStoredActiveTab = (prefix: string, tabKey: string) =>
  sessionStorage.setItem(tabActiveKey(prefix), tabKey);

export const clampPage = (current: number, total: number, pageSize: number) => {
  const maxPage = Math.max(1, Math.ceil(total / pageSize) || 1);
  return Math.min(current || 1, maxPage);
};

/**
 * Resolve the page to show for a tab after totals update.
 * When total is 0 (still loading / empty unknown), keep the stored page and
 * do NOT write sessionStorage — otherwise refresh on page 2+ resets to 1.
 */
export const resolveTabPage = (
  storagePrefix: string,
  tabKey: string,
  current: number,
  total: number,
  pageSize: number
) => {
  const stored = getStoredTabPage(storagePrefix, tabKey);
  const preferred = stored || current || 1;

  if (total <= 0) {
    return preferred;
  }

  const next = clampPage(preferred, total, pageSize);
  if (next !== stored) {
    setStoredTabPage(storagePrefix, tabKey, next);
  }
  return next;
};

export function visibleStatusTabs<T extends { key: string; count: number }>(
  panes: T[]
): T[] {
  const withData = panes.filter((pane) => pane.count > 0);
  return withData.length > 0 ? withData : [panes[0]];
}

export const resolveActiveTab = (
  storedKey: string,
  visiblePanes: { key: string }[]
) =>
  visiblePanes.some((pane) => pane.key === storedKey)
    ? storedKey
    : visiblePanes[0]?.key ?? "1";
